<template>
  <div class="user-select-list" :class="{'user-select-list_danger': danger}">
    <div v-if="label" class="user-select-list__label">
      {{label}}
    </div>

    <div class="user-select-list__content">
      <app-input placeholder="Фио" v-model="searchString" class="user-select-list__search">
        <app-icon name="SearchIcon" slot="prepend" size="14px"/>
      </app-input>

      <div class="user-select-list__body">
        <div v-if="!isLoaded && !isLoading" class="user-select-list__no-users">
          {{notLoadedMessage}}
        </div>
        <VuePerfectScrollbar v-else-if="!isLoading && filteredUsers.length" class="user-select-list__list-scroll">
          <ul class="user-select-list__list">
            <li v-for="user in filteredUsers" :key="user.id" class="user-select-list__item" @click="model = user.id" :class="{'user-select-list__item_active': model === user.id}">
              <app-avatar :img="$options.filters.imgPath(user.avatar)" :name="user.name"
                          class="user-select-list__avatar" size="28px"/>
              <span class="user-select-list__name">{{user.name}}</span>
            </li>
          </ul>
        </VuePerfectScrollbar>
        <div v-else-if="!isLoading && !filteredUsers.length" class="user-select-list__no-users">
          Пользователи не найдены
        </div>
        <div class="user-select-list__loading" v-else>
          <div class="block-loading"></div>
        </div>
      </div>

    </div>

    <transition name="fade">
      <div class="user-select-list__validation-error" v-if="danger && dangerText.length">
        {{dangerText}}
      </div>
    </transition>
  </div>
</template>

<script>
  import VuePerfectScrollbar from 'vue-perfect-scrollbar';

  export default {
    name: "UsersSelectList",
    components: {VuePerfectScrollbar},
    props: {
      label: {},
      users: {},
      value: {},
      danger: {default: false, type: Boolean},
      dangerText: {
        default: ""
      },
      isLoading: {
        default: false,
        type: Boolean
      },
      isLoaded: {
        default: true,
        type: Boolean
      },
      notLoadedMessage: {}
    },
    data() {
      return {
        searchString: ""
      }
    },
    computed: {
      filteredUsers(){
        if(this.searchString === null || !this.searchString.length) return this.users;
        return this.users.filter(user => user.name.toLowerCase().includes(this.searchString.toLowerCase()));
      },
      model: {
        get(){
          return this.value;
        },
        set(v){
          this.$emit('update:danger', false);
          this.$emit('input', v);
        }
      }
    }
  }
</script>

<style lang="scss">
  .user-select-list {
    $searchHeight: 36px;
    position: relative;

    &__label {
      color: rgba(var(--app-heading-color-light), 1);
      font-size: 14px;
      margin-bottom: 2px;
      display: block;
    }

    &__content {
      border-radius: 2px !important;
      border: 1px solid #ced4da !important;
      height: 320px;
    }

    &__body{
      height: calc(100% - #{$searchHeight} - 4px);
    }

    &__search{
      &.app-input {
        width: 100%;

        .app-input{
          &__body {
            border-radius: 0px;
            height: $searchHeight;
            border: none;
            border-bottom: 1px solid #ced4da !important;
          }

          &__prepend {
            width: 33px;
            background: transparent;
            border: none;
            padding: 0;
            border-top-left-radius: 0px;
            border-bottom-left-radius: 0px;
            padding-left: 5px;
            color: #86939e;
          }
        }

        input {
          padding: 5px 10px 5px 0;
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
          line-height: 1.2;
          font-size: 13px;
        }
      }
    }

    &__item{
      display: flex;
      align-items: center;
      padding: 10px;
      border-left: 2px solid transparent;
      border-bottom: 1px solid #ced4da;

      &:hover{
        background: #f5f8fa;
        cursor: pointer;
      }

      &_active{
        border-left-color: rgba(var(--vs-primary), 1);
        background: #f5f8fa;
      }
    }

    &__avatar{
      margin-right: 10px;
      flex-shrink: 0;
    }

    &__name{
      line-height: 1.1;
      color: rgba(var(--app-heading-color), 1);
      font-size: 14px;
    }

    &__loading{
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      height: 100%;

      .block-loading{
        flex: 0;

        &::before{
          width: 30px;
          height: 30px;
        }
      }
    }

    &__no-users{
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      height: 100%;
      line-height: 1.1;
      color: rgba(var(--app-heading-color), 1);
      font-size: 16px;
    }

    &__list-scroll{
     height: 100%;
    }

    &_danger{
      .user-select-list__content{
        border: 1px solid rgba(var(--app-danger), 1) !important;
      }
    }

    &__validation-error{
      display: inline-block;
      color: rgba(var(--app-danger), 1);
      overflow: hidden;
      transition: all .25s ease;
      border: 1px solid #eee;
      background: #fff;
      box-shadow: 0 10px 12px rgba(0, 0, 0, .2);
      margin-top: 3px;
      font-weight: 600;
      text-transform: uppercase;
      padding: 4px;
      line-height: 1.2;
      font-size: 10px;
      border-radius: 2px;
      z-index: 100;
      position: absolute;
      top: 100%;
      left: 0;
    }

  }
</style>